// ============================================================
// services/casoConvivenciaService.ts
// /casos-convivencia — incidentes, actores, SíseVe.
// ============================================================

import { httpClient } from 'utils/httpClient';
import {
  CasoConvivenciaPayload,
  CasoEstadoPayload,
  CasoConvivenciaResponse,
  CasoFiltros,
  ActorCasoPayload,
  ActorCasoResponse,
} from 'types/psicologia.types';

export const casoConvivenciaService = {

  async crear(payload: CasoConvivenciaPayload): Promise<CasoConvivenciaResponse> {
    return httpClient.post<CasoConvivenciaResponse>('/casos-convivencia', payload);
  },

  async listar(filtros: CasoFiltros = {}, signal?: AbortSignal): Promise<CasoConvivenciaResponse[]> {
    const q = new URLSearchParams();
    if (filtros.estado)   q.set('estado',   filtros.estado);
    if (filtros.gravedad) q.set('gravedad', filtros.gravedad);
    if (filtros.desde)    q.set('desde',    filtros.desde);
    if (filtros.hasta)    q.set('hasta',    filtros.hasta);
    const qs = q.toString();
    const data = await httpClient.get<CasoConvivenciaResponse[]>(
      `/casos-convivencia${qs ? `?${qs}` : ''}`,
      signal ? { signal } : undefined,
    );
    return Array.isArray(data) ? data : [];
  },

  async obtener(id: number): Promise<CasoConvivenciaResponse> {
    return httpClient.get<CasoConvivenciaResponse>(`/casos-convivencia/${id}`);
  },

  async actualizar(id: number, payload: CasoConvivenciaPayload): Promise<CasoConvivenciaResponse> {
    return httpClient.put<CasoConvivenciaResponse>(`/casos-convivencia/${id}`, payload);
  },

  async actualizarEstado(id: number, payload: CasoEstadoPayload): Promise<CasoConvivenciaResponse> {
    return httpClient.put<CasoConvivenciaResponse>(`/casos-convivencia/${id}/estado`, payload);
  },

  async marcarSiseVe(id: number, reportado: boolean): Promise<CasoConvivenciaResponse> {
    return httpClient.put<CasoConvivenciaResponse>(`/casos-convivencia/${id}/sise-ve`, { reportado });
  },

  async eliminar(id: number): Promise<void> {
    return httpClient.delete<void>(`/casos-convivencia/${id}`);
  },

  async agregarActor(idCaso: number, payload: ActorCasoPayload): Promise<ActorCasoResponse> {
    return httpClient.post<ActorCasoResponse>(`/casos-convivencia/${idCaso}/actores`, payload);
  },

  async eliminarActor(idCaso: number, idActor: number): Promise<void> {
    return httpClient.delete<void>(`/casos-convivencia/${idCaso}/actores/${idActor}`);
  },
};
